import { MdOutlineExpandMore, MdOutlineQueryStats } from 'react-icons/md'
import { composeClasses } from '@wiggot/utils/src/strings'
import PoweredByMonopolio from '../../monopolioBrand/PoweredByMonopolio'

interface Props {
  expandedDirection?: 'top' | 'bottom'
  isExpanded: boolean
  onClick: () => void
}

const SeeToggle = ({
  expandedDirection = 'bottom',
  isExpanded,
  onClick,
}: Props): JSX.Element => {
  // const { trackEvent } = useAmplitude()

  const onSelected = () => {
    onClick()

    // if (!isOpenned) {
    //   trackEvent({
    //     name: EAmplitudeEvent.ZONE_INSIGHTS_SELECTED
    //   })
    // }
  }

  return (
    <button
      type="button"
      className={composeClasses(
        'w-full  gap-3 py-2 items-center px-4 cursor-pointer duration-300',
        isExpanded
          ? 'flex justify-between bg-white'
          : 'flex justify-between bg-[#F4F7FA]'
      )}
      onClick={onSelected}
    >
      <div className="text-left">
        <div
          className={`flex items-center ${isExpanded ? 'gap-3' : 'gap-[5px]'}`}
        >
          {isExpanded && (
            <div className="p-2 rounded-full flex items-center justify-center bg-notif-blue-01">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M19.88 17.97C20.32 17.27 20.58 16.46 20.58 15.58C20.58 13.09 18.57 11.08 16.08 11.08C13.59 11.08 11.58 13.09 11.58 15.58C11.58 18.07 13.59 20.08 16.07 20.08C16.95 20.08 17.77 19.82 18.46 19.38L21.58 22.5L23 21.08L19.88 17.97ZM16.08 18.08C14.7 18.08 13.58 16.96 13.58 15.58C13.58 14.2 14.7 13.08 16.08 13.08C17.46 13.08 18.58 14.2 18.58 15.58C18.58 16.96 17.46 18.08 16.08 18.08ZM15.72 9.58C14.98 9.6 14.27 9.76 13.62 10.03L13.07 9.2L9.27 15.38L6.26 11.86L2.63 17.67L1 16.5L6 8.5L9 12L13 5.5L15.72 9.58ZM18.31 10.08C17.67 9.8 16.98 9.63 16.26 9.59L21.38 1.5L23 2.68L18.31 10.08Z"
                  fill="#0038FF"
                />
              </svg>
            </div>
          )}
          <p
            className={`duration-300 ${
              isExpanded ? 'text-primary flex flex-col' : 'text-primary'
            }
            ${isExpanded ? 'text-body-l' : 'text-sm font-semibold'}
            `}
          >
            Información de la zona
            {isExpanded && (
              <span className="text-secondary text-xs">
                Resumen de las propiedades relacionadas a tu búsqueda
              </span>
            )}
          </p>
          {isExpanded ? null : (
            <div className="mt-0.5 animation-appear-03">
              <PoweredByMonopolio />
            </div>
          )}
        </div>
      </div>

      <div className="flex items-center justify-center">
        <MdOutlineExpandMore
          className={composeClasses(
            '[transition:transform_200ms] w-6 h-6 fill-primary',
            isExpanded ? 'transform ' : '',
            expandedDirection === 'top' ? 'rotate-180' : '',
            isExpanded && expandedDirection === 'bottom' ? '!rotate-180' : '',
            isExpanded && expandedDirection === 'top' ? '!rotate-0' : ''
          )}
        />
      </div>
    </button>
  )
}

export default SeeToggle
